import { Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private snackBar: MatSnackBar) {}

  public showSuccessMsg(msg): void {
    this.snackBar.open(msg, null, {
      duration: 2500,
      panelClass: 'snackbar'
    })
  }

  public showErrorMsg(msg, timeout: number = 2500): void {
    this.snackBar.open(msg, 'OK', {
      duration: timeout,
      panelClass: ['toast', 'toast-error']
    })
  }

  public showWarningMsg(msg, action: string = 'OK'): void {
    this.snackBar.open(msg, action, {
      duration: 2500,
      panelClass: ['toast', 'toast-warning']
    })
  }
}
